module.exports = __webpack_public_path__ + "static/img/promo_order_1.4cc277b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promo_order_1.jpg
// module id = fUEF
// module chunks = 0